import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_earningtype,
  add_earningtype,
  update_earningtype,
  delete_earningtype,
  get_earningtype_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    earningtype: [],
    earningtypelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchearningtypelist = createAsyncThunk(
    'earningtype/fetchearningtypelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_earningtype_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchearningtype = createAsyncThunk(
  "earningtype/fetchearningtype",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_earningtype(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createearningtype = createAsyncThunk(
  "earningtype/createearningtype",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_earningtype(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateearningtype = createAsyncThunk(
  "earningtype/updateearningtype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_earningtype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteearningtype = createAsyncThunk(
  "earningtype/deleteearningtype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_earningtype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const earningtypeSlice = createSlice({
  name: 'earningtypes',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:""
      };
    },
    setearningtype(state, action) {
      state.earningtype = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchearningtypelist.fulfilled, (state, action) => {
        state.earningtypelist = action.payload.data;
      })
      .addCase(fetchearningtypelist.rejected, (state, action) => {
        state.earningtypelist = [];

      })

       // Fetch hostel_category
       .addCase(fetchearningtype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchearningtype.fulfilled, (state, action) => {
        state.loading = false;
        state.earningtype = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchearningtype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createearningtype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createearningtype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.earningtype = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createearningtype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateearningtype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateearningtype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateearningtype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteearningtype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteearningtype.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteearningtype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setearningtype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = earningtypeSlice.actions;
export default earningtypeSlice.reducer;
